import { appRouteDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createDevRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('../layouts/dev-layout.vue'),
      children: [
        {
          path: '',
          name: appRouteDefinitions.dev.httpClient,
          component: () => import('../views/dev-http-client.vue')
        },
        {
          path: 'signalr',
          name: appRouteDefinitions.dev.signalR,
          component: () => import('../views/dev-signalr.vue')
        },
        {
          path: 'fredrik',
          name: appRouteDefinitions.dev.fredrik,
          component: () => import('../views/dev-fredrik.vue')
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
